import * as echarts from 'echarts'
import {bigNumberTransform} from '../util/base'

var xIndex = ''
// var xData = ''
// var yData = ''
// var vol = ''
var ma1 = ''
var ma2 = ''
var ma3 = ''
var boll_mid = ''
var macd = ''
var diff = ''
var dea = ''
var macd_2 = ''
var diff_2 = ''
var dea_2 = ''

const colorList = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3']
const upColor = '#DC143C'
const downColor = '#3CB371'
const whiteColor = '#FFFFFF'

function setHeader (chart, pointInPixel) {
  // console.log(chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel))
  xIndex = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0]
  // xData = chart.getOption().xAxis[0].data[xIndex]
  // yData = chart.getOption().series[0].data[xIndex]
  // vol = chart.getOption().series[1].data[xIndex].value
  ma1 = chart.getOption().series[2].data[xIndex]
  ma2 = chart.getOption().series[3].data[xIndex]
  ma3 = chart.getOption().series[4].data[xIndex]
  boll_mid = chart.getOption().series[5].data[xIndex]
  // if (chart.getOption().series[6].data[xIndex] != null){
  //   macd = chart.getOption().series[6].data[xIndex].value
  // }
  macd = chart.getOption().series[6].data[xIndex]
  diff = chart.getOption().series[7].data[xIndex]
  dea = chart.getOption().series[8].data[xIndex]
  if (chart.getOption().series[9].data[xIndex] != null){
    macd_2 = chart.getOption().series[9].data[xIndex].value
  }  
  diff_2 = chart.getOption().series[10].data[xIndex]
  dea_2 = chart.getOption().series[11].data[xIndex]
  // if (chart.getOption().series[5].data[xIndex] != null) {
  //   macd = chart.getOption().series[5].data[xIndex].value
  // } else {
  //   macd = ''
  // }
}

function splitData (rawData) {
  const categoryData = []
  const values = []
  const volumes = []
  for (let i = 0; i < rawData.length; i++) {
    categoryData.push(rawData[i].splice(0, 1)[0])
    values.push(rawData[i])
    // volumes.push(rawData[i][4]);
    if (rawData[i][0] > rawData[i][1]) {
      volumes.push({ value: rawData[i][4], itemStyle: { normal: { color: downColor }, emphasis: { color: downColor } } })
    } else {
      volumes.push({ value: rawData[i][4], itemStyle: { normal: { color: whiteColor, borderColor: upColor }, emphasis: { color: whiteColor, borderColor: upColor } } })
    }
    // volumes.push([i, rawData[i][4], rawData[i][0] > rawData[i][1] ? 1 : -1]);
  }
  // console.log(values)
  // console.log(volumes)
  return {
    categoryData: categoryData,
    values: values,
    volumes: volumes
  }
}

function getMACD (rawMACD) {
  const macdList = []
  rawMACD.forEach(item => {
    if (item < 0) {
      macdList.push({ value: item, itemStyle: { normal: { color: downColor }, emphasis: { color: downColor } } })
    } else if (item > 0) {
      macdList.push(item = { value: item, itemStyle: { normal: { color: upColor }, emphasis: { color: upColor } } })
    } else {
      macdList.push(item = { value: item, itemStyle: { normal: { color: whiteColor }, emphasis: { color: whiteColor } } })
    }
  })
  return macdList
}

function setTooltipStyle (filed, base) {
  var style = ''
  if (filed > base) {
    style = 'color:red'
  } else if (filed < base) {
    style = 'color:green'
  } else {
    style = ''
  }
  return style
}

function setTooltip (params) {
  var date = params[0].name // 日期
  // var idx = params[0].value[0] // 索引
  var open = params[0].value[1] // 开盘
  var close = params[0].value[2] // 收盘
  var low = params[0].value[3] // 最低
  var high = params[0].value[4] // 最高
  var vol = bigNumberTransform(params[0].value[5]) // 总手
  var opi = bigNumberTransform(params[0].value[6]) // 持仓
  var sett = params[0].value[7] // 结算
  var chg = params[0].value[8] // 涨跌
  var chgPct = params[0].value[9] // 涨幅
  var volChg = params[0].value[10] // 增量
  var opiChg = params[0].value[11] // 增仓
  var preClose = params[0].value[12] // 前收
  // var preSett = params[0].value[13] // 前结
  // var amplitude = params[0].value[14] // 振幅

  var openStyle = ''
  var closeStyle = ''
  var lowStyle = ''
  var highStyle = ''
  var chgStyle = ''
  var volStyle = ''
  var opiStyle = ''
  // var settStyle = ''
  openStyle = setTooltipStyle(open, preClose)
  closeStyle = setTooltipStyle(close, preClose)
  lowStyle = setTooltipStyle(low, preClose)
  highStyle = setTooltipStyle(high, preClose)
  chgStyle = setTooltipStyle(chg, 0)
  volStyle = setTooltipStyle(volChg, 0)
  opiStyle = setTooltipStyle(opiChg, 0)
  if (volChg > 0) {
    volChg = '+' + volChg
  }
  if (opiChg > 0) {
    opiChg = '+' + opiChg
  }

  return date + '<br/>' +
    `开盘: <span style=${openStyle}> ${open} </span><br/>` +
    `最高: <span style=${highStyle}> ${high} </span><br/>` +
    `最低: <span style=${lowStyle}> ${low} </span><br/>` +
    `收盘: <span style=${closeStyle}> ${close} </span><br/>` +
    `涨跌: <span style=${chgStyle}>${chg} ${chgPct}% </span><br/>` +
    `成交: ${vol}<span style=${volStyle}> ${volChg} </span><br/>` +
    `持仓: ${opi}<span style=${opiStyle}> ${opiChg} </span><br/>` +
    `结算: <span> ${sett} </span><br/>`
}

function setTooltip2 (params) {
  var date = params[0].name // 日期
  // var idx = params[0].value[0] // 索引
  var open = params[0].value[1] // 开盘
  var close = params[0].value[2] // 收盘
  var low = params[0].value[3] // 最低
  var high = params[0].value[4] // 最高
  var vol = bigNumberTransform(params[0].value[5] / 100) // 总手
  var chg = params[0].value[6] // 涨跌
  var chgPct = params[0].value[7] // 涨幅
  var volChg = (params[0].value[8] / 100).toFixed(0) // 增量
  var preClose = params[0].value[9] // 前收

  var openStyle = ''
  var closeStyle = ''
  var lowStyle = ''
  var highStyle = ''
  var chgStyle = ''
  var volStyle = ''

  openStyle = setTooltipStyle(open, preClose)
  closeStyle = setTooltipStyle(close, preClose)
  lowStyle = setTooltipStyle(low, preClose)
  highStyle = setTooltipStyle(high, preClose)
  chgStyle = setTooltipStyle(chg, 0)
  volStyle = setTooltipStyle(volChg, 0)
  if (volChg > 0) {
    volChg = '+' + volChg
  }

  return date + '<br/>' +
    `开盘: <span style=${openStyle}> ${open} </span><br/>` +
    `最高: <span style=${highStyle}> ${high} </span><br/>` +
    `最低: <span style=${lowStyle}> ${low} </span><br/>` +
    `收盘: <span style=${closeStyle}> ${close} </span><br/>` +
    `涨跌: <span style=${chgStyle}>${chg} ${chgPct}% </span><br/>` +
    `成交: ${vol}<span style=${volStyle}> ${volChg} </span><br/>`
}

const setEvent = (myChart, mouseMoveCallback) => {
  myChart.getZr().off('mousemove', function () {}) // 注销事件

  // var isApShow = false
  myChart.getZr().on('mousemove', params => {
    // if (!isApShow) {
    //   myChart.setOption({
    //     xAxis: [{ axisPointer: { status: 'hide' } }, { axisPointer: { status: 'hide' } }],
    //     yAxis: [{ axisPointer: { status: 'hide' } }, { axisPointer: { status: 'hide' } }]
    //   })
    //   return // 十字准星未开启前，禁止事件触发
    // }

    const pointInPixel = [params.offsetX, params.offsetY]
    // console.log(pointInPixel)
    if (myChart.containPixel({ seriesIndex: [0, 1] }, pointInPixel)) {
      setHeader(myChart, pointInPixel)
    }
    
    mouseMoveCallback(ma1, ma2, ma3, boll_mid, macd, diff, dea, macd_2, diff_2, dea_2)
    // mouseMoveCallback(ma1, ma2, ma3, boll_mid, k, d, j, macd_2, diff_2, dea_2)
    // myChart.setOption({ title: [{ text: ma1 + ma2 + ma3 }] }) // setOption特别卡顿，原因不明
  })
}

// var myChart = null
const setCharts = (chartDom, title, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ, mouseMoveCallback) => {
  // if (myChart === null) { // 只有第一次才实例化
  //   var myChart = echarts.init(chartDom)
  // } 
  echarts.dispose(chartDom)
  var myChart = echarts.init(chartDom)
  var option = calcOption(title, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ)
  option && myChart.setOption(option)
  setEvent(myChart, mouseMoveCallback)
  
  return myChart
}

const calcOption = (title, rawData, rawMa, rawMACD, rawMACD_2, rawBoll, rawKDJ) => {
  
  const data0 = splitData(rawData)
  const macdData = getMACD(rawMACD.map(item => item.MACD))
  const diffData = rawMACD.map(item => item.DIFF)
  const deaData = rawMACD.map(item => item.DEA)

  const macdData_2 = getMACD(rawMACD_2.map(item => item.MACD))
  const diffData_2 = rawMACD_2.map(item => item.DIFF)
  const deaData_2 = rawMACD_2.map(item => item.DEA)

  const ma5Data = rawMa.map(item => item.MA_1)
  const ma10Data = rawMa.map(item => item.MA_2)
  const ma20Data = rawMa.map(item => item.MA_3)

  const bollData = rawBoll.map(item => item.BOLL_MID)

  const KData = rawKDJ.map(item => item.K)
  const DData = rawKDJ.map(item => item.D)
  const JData = rawKDJ.map(item => item.J)
  
  var option = {
    color: colorList,
    title: {
      left: 'left',
      text: title,
      textStyle: {
        // color: "#000", // 主标题文字的颜色。
        // fontStyle: "normal", // 主标题文字字体的风格。 'normal'  'italic'  'oblique'
        fontWeight: 'normal', // 主标题文字字体的粗细。 'normal' 'bold'  'bolder'  'lighter' 500|600
        // fontFamily: "sans-serif", // 主标题文字的字体系列。
        fontSize: 12 // 字体大小
      }
    },
    tooltip: {
      trigger: 'axis',
      show: true,
      // enterable: true,
      formatter: setTooltip2
      // axisPointer: {
      //   animation: false,
      //   type: 'cross',
      //   // lineStyle: {
      //   //   color: '#e0e0e0',
      //   //   type:'dotted',  //'dotted'虚线 'solid'实线
      //   //   width: 1,
      //   //   opacity: 1
      //   // },
      //   label: {
      //     show: false
      //   }
      // },
    },
    axisPointer: {
      link: [
        {
          // xAxisIndex: [0,1]
          xAxisIndex: 'all'
        }
      ],
      // crossStyle: {
      //   color: '#000'
      // },
      label: {
        backgroundColor: '#777'
      },
      show: false
    },
    grid: [
      {
        left: '0%',
        right: '17%',
        top: '5%',
        height: '65%'
      },
      {
        left: '0%',
        right: '17%',
        top: '70%',
        height: '10%'
      },
      {
        left: '0%',
        right: '17%',
        top: '80%',
        height: '10%'
      },
      {
        left: '0%',
        right: '17%',
        top: '90%',
        height: '10%'
      }
    ],
    dataZoom: [
      {
        type: 'inside',
        xAxisIndex: [0, 1, 2, 3],
        start: 0,
        end: 100
      }
    ],
    xAxis: [
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        type: 'category',
        data: data0.categoryData,
        axisPointer: {
          show: true,
          label: {
            show: true
          }
        }
        // scale: true,
        // boundaryGap: false,
        // axisLine: { onZero: false },
        // splitLine: { show: false },
        // min: 'dataMin',
        // max: 'dataMax',
        // axisPointer: {
        //   z: 100
        // }
      },
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        type: 'category',
        gridIndex: 1,
        data: data0.categoryData
        // axisPointer: {
        //   show: true,
        //   label: {
        //     show: false
        //   }
        // }
      },
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        type: 'category',
        gridIndex: 2,
        data: data0.categoryData
        // axisPointer: {
        //   show: true,
        //   label: {
        //     show: false
        //   }
        // }
      },
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        type: 'category',
        gridIndex: 3,
        data: data0.categoryData
        // axisPointer: {
        //   show: true,
        //   label: {
        //     show: false
        //   }
        // }
      }
    ],
    yAxis: [
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        splitLine: { show: false },
        scale: true,
        axisPointer: {
          show: true
        }
      },
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        splitLine: { show: false },
        scale: true,
        gridIndex: 1
        // axisPointer: {
        //   show: true
        // }
        // splitNumber: 2,
        // axisLabel: { show: false },
        // axisLine: { show: false },
        // axisTick: { show: false },
        // splitLine: { show: false }
      },
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        splitLine: { show: false },
        scale: true,
        gridIndex: 2
        // axisPointer: {
        //   show: true
        // }
        // splitNumber: 2,
        // axisLabel: { show: false },
        // axisLine: { show: false },
        // axisTick: { show: false },
        // splitLine: { show: false }
      },
      {
        axisLabel: {
          show: false
        },
        axisLine: {
          lineStyle: {
            color: '#e0e0e0'
          }
        },
        splitLine: { show: false },
        scale: true,
        gridIndex: 3
        // axisPointer: {
        //   show: true
        // }
        // splitNumber: 2,
        // axisLabel: { show: false },
        // axisLine: { show: false },
        // axisTick: { show: false },
        // splitLine: { show: false }
      }
    ],
    // dataZoom: [
    //   {
    //     type: 'inside',
    //     xAxisIndex: [0, 1],
    //     start: 0,
    //     end: 100
    //   },
    //   {
    //     show: true,
    //     xAxisIndex: [0, 1],
    //     type: 'slider',
    //     top: '65%',
    //     start: 0,
    //     end: 100
    //   }
    // ],
    // brush: {
    //   xAxisIndex: 'all',
    //   brushLink: 'all',
    //   outOfBrush: {
    //     colorAlpha: 0.1
    //   }
    // },
    series: [
      {
        name: 'K线',
        type: 'candlestick',
        data: data0.values,
        itemStyle: {
          color: whiteColor,
          color0: downColor,
          borderColor: upColor,
          borderColor0: downColor
        },
        emphasis: {
          itemStyle: {
            borderWidth: 1
          }
        }
      },
      {
        name: 'Volume',
        type: 'bar',
        xAxisIndex: 1,
        yAxisIndex: 1,
        data: data0.volumes
      },
      {
        name: 'MA5',
        type: 'line',
        data: ma5Data,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'black',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'MA10',
        type: 'line',
        data: ma10Data,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'blue',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'MA20',
        type: 'line',
        data: ma20Data,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'pink',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'boll_mid',
        type: 'line',
        data: bollData,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'orange',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'K',
        type: 'line',
        xAxisIndex: 2,
        yAxisIndex: 2,
        data: KData,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'black',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'D',
        type: 'line',
        xAxisIndex: 2,
        yAxisIndex: 2,
        data: DData,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'blue',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'J',
        type: 'line',
        xAxisIndex: 2,
        yAxisIndex: 2,
        data: JData,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'pink',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'MACD_2',
        type: 'bar',
        xAxisIndex: 3,
        yAxisIndex: 3,
        data: macdData_2
      },
      {
        name: 'MACD_2',
        type: 'line',
        xAxisIndex: 3,
        yAxisIndex: 3,
        data: diffData_2,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'black',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      },
      {
        name: 'MACD_2',
        type: 'line',
        xAxisIndex: 3,
        yAxisIndex: 3,
        data: deaData_2,
        smooth: true,
        showSymbol: false,
        symbol: 'none',
        lineStyle: {
          color: 'blue',
          width: 1,
          emphasis: {
            width: 1
          }
        }
      }
    ]
  }

  return option

  // option && myChart.setOption(option)

  // myChart.getZr().off('mousemove', function () {}) // 注销事件

  // // var isApShow = false
  // myChart.getZr().on('mousemove', params => {
  //   // if (!isApShow) {
  //   //   myChart.setOption({
  //   //     xAxis: [{ axisPointer: { status: 'hide' } }, { axisPointer: { status: 'hide' } }],
  //   //     yAxis: [{ axisPointer: { status: 'hide' } }, { axisPointer: { status: 'hide' } }]
  //   //   })
  //   //   return // 十字准星未开启前，禁止事件触发
  //   // }

  //   const pointInPixel = [params.offsetX, params.offsetY]
  //   // console.log(pointInPixel)
  //   if (myChart.containPixel({ seriesIndex: [0, 1] }, pointInPixel)) {
  //     setHeader(myChart, pointInPixel)
  //   }
  //   mouseMoveCallback(ma1, ma2, ma3, boll_mid, macd, diff, dea, macd_2, diff_2, dea_2)
  //   // myChart.setOption({ title: [{ text: ma1 + ma2 + ma3 }] }) // setOption特别卡顿，原因不明
  // })

  // return myChart
}

export { setCharts, calcOption, setEvent }
